<template>
	<div class="wrapper-with-borders flex-row flex-between">
		<review-stars
			:rating="product.avgRating"
			:total-reviews="product.numReviews"
			:blain-number="product.blainNumber"
			star-size="22px"
		/>
		<social-icons
			:facebook-url="facebookUrl"
			:instagram-url="instagramUrl"
			:pinterest-url="pinterestUrl"
			linked-in-url=""
			you-tube-url=""
			tik-tok-url=""
		/>
	</div>
</template>
<script>
import ReviewStars from '../../components/ReviewStars.vue';
import SocialIcons from '../../components/SocialIcons.vue';
export default {
	name: 'ReviewAndSocial',
	components: {
		ReviewStars,
		SocialIcons
	},
	computed: {
		product() {
			return this.$store.state.product;
		},
		thisUrl() {
			return `https://www.farmandfleet.com${this.product.url}`;
		},
		facebookUrl() {
			return `https://www.facebook.com/sharer/sharer.php?u=${this.thisUrl}`;
		},
		instagramUrl() {
			return null; // TODO;
		},
		pinterestUrl() {
			return `https://pinterest.com/pin/create/button/?url=&media=&description=${this.thisUrl}`;
		},
	}
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';
.wrapper-with-borders {
	border-top: 1px solid #CCCCCC;
	border-bottom: 1px solid #CCCCCC;
	position: relative;
	padding: 9px 9px 9px 1px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-flow: row;
}
</style>
